import { isDimensionBased } from "../../../../../utilities/fieldsHelper.ts";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";

export function isFieldSupportedLogoIcon(field: ReportField) {
  return (isDimensionBased(field) && field.meta.name === "InvestmentNo") || field.meta.name === "InvestmentName";
}
